module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer_EN_VN.0433c065.png";